import axios from "axios";

export const orderApi = {
  order(formData: FormData) {
    return axios.post("/api/v1/order/", formData).then((res) => res);
  },
};
